import { component, prop } from '../../decorators';

import Ellipsis from '../common/ellipsis/ellipsis.vue';

import { CLIP_TYPE_CODE } from '../../config';

@component({
   components: { Ellipsis }
})
export default class ClipDetails {
   @prop({ type: Object, required: true }) clip
   @prop({ type: Boolean, default: false }) showType;

   get isClip() {
      return this.clip.type === CLIP_TYPE_CODE;
   }

   get dialogue() {
      return this.isClip ? (this.clip.dialogue || '').split('\n').join('<br>') : '';
   }
}
